export const CDN_BASE_URL = 'https://cdn.cloubot.com';
export const CLASS_STATUS_TYPE_ALL = 0;
export const CLASS_STATUS_TYPE_IN_PRGRESS = 1;
export const CLASS_STATUS_TYPE_FINISH = 2;

export const MAX_SEARCH_INTERVAL_DAYS = 93;
export const DATE_SEARCH_OPTIONS = [
  {
    name: '월선택',
    value: 0,
  },
  {
    name: '기간선택',
    value: 1,
  },
];

export const DATE_SEARCH_OPTIONS_FOR_AFTER_SCHOOL = [
  {
    name: '전체',
    value: -1,
  },
  {
    name: '월선택',
    value: 0,
  },
  {
    name: '기간선택',
    value: 1,
  },
];

export const BOOK_RETURN_STATS = ['반품접수', '반품완료'];

export const DELIVERY_STATUS_REG = '0'; //주문
export const DELIVERY_STATUS_READY = '1'; //주문 확인(출고준비)
export const DELIVERY_STATUS_COMPLETE = '2'; //송장번호입력(출고완료)

export const DELIVERY_STATUS_STATUS_COLOR_LIST = [
  '#4dabf7', //접수(주문서)
  '#ff922b', //주문서확인(출고준비)
  '#e03131', //송장입력(출고완료)
];

export const DELIVERY_STATUS_STATUS_TEXT_LIST = [
  '주문서', //접수(주문서)
  '출고준비', //주문서확인(출고준비)
  '출고완료', //송장입력(출고완료)
];

export const DELIVERY_STATUS_STATUS_TEXT_LIST_FOR_DASHBOARD = [
  '주문접수', //접수(주문서)
  '출고준비', //주문서확인(출고준비)
  '출고완료', //송장입력(출고완료)
];

export const DELIVERY_STATUS_STATUS_TEXT_LIST_FOR_CAMPUS = [
  '주문서', //접수(주문서)
  '접수', //주문서확인(출고준비)
  '출고', //송장입력(출고완료)
];

//진행단계 [level 1: 배송준비중, 2: 집화완료, 3: 배송중, 4: 지점 도착, 5: 배송출발, 6:배송 완료]
export const DELEVERY_LEVEL_TEXT_LIST = [
  '', //level 1부터 있어서, 0은 무시..
  '배송준비중',
  '집화완료',
  '배송중',
  '지점 도착',
  '배송출발',
  '배송 완료',
];

//SMS 관련 상수
export const MSG_TYPE_SMS = '0';
export const MSG_TYPE_LMS = '1';
export const MSG_TYPE_MMS = '2';
export const MSG_TYPE_TALK = '3';
export const MSG_FEE_LIST = {
  0: 12,
  1: 35,
  2: 35,
  3: 9,
};
export const MSG_TYPE_TEXT_LIST = {
  0: '단문',
  1: '장문',
  2: 'MMS',
  3: '알림톡',
};
export const MAX_SMS_BYTES = 90;

export const MXLEVEL_TO_AGL = {
  PH: 'K1 ~ K2',
  1: 'K3',
  2: '1.1 ~ 1.2',
  3: '1.3 ~ 1.6',
  4: '1.7 ~ 2.2',
  5: '2.3 ~ 2.7',
  6: '2.8 ~ 3.3',
  7: '3.4 ~ 4.1',
  8: '4.2 ~ 4.8',
  9: '4.9 ~ 6.0',
  10: '6.1 ~ 7.4',
  11: '7.5 ~ 10.0',
  12: '10.1 ~ 13.5',
};

export const MXLEVEL_TO_LEXILE = {
  PH: 'Phonics',
  0: 'Phonics',
  1: 'BR100 ~ 0',
  2: '1L ~ 100L',
  3: '101L ~ 250L',
  4: '251L ~ 400L',
  5: '401L ~ 500L',
  6: '501L ~ 600L',
  7: '601L ~ 700L',
  8: '701L ~ 790L',
  9: '791L ~ 900L',
  10: '901L ~ 1,000L',
  11: '1,001L ~ 1,160L',
  12: '1,161L ~ 1,350L',
};

export const EDUCO_LEXILE_SCORE = {
  RCA: [
    {
      min: 0,
      max: 9,
      level: 'Prep 3',
      level_no: 0,
      lexile: '400L ~ 500L',
      grade: '내신 ( 중1 )',
      comment: '중1 교과서 수준 읽고 이해 / 과거 시제까지',
    },
    {
      min: 10,
      max: 16,
      level: 'Level 1',
      level_no: 1,
      lexile: '450L ~ 550L',
      grade: '내신 ( 중2 )',
      comment: '중2 교과서 수준 읽고 이해 / 관계 절 까지',
    },
    {
      min: 17,
      max: 22,
      level: 'Level 2',
      level_no: 2,
      lexile: '550L ~ 650L',
      grade: '내신 ( 중3 )',
      comment: '중3 교과서 수준 읽고 이해 / 중등 문법 전체',
    },
    {
      min: 23,
      max: 26,
      level: 'Level 3',
      level_no: 3,
      lexile: '650L ~ 750L',
      grade: '내신 ( 중3 [상] )',
      comment: '고1 수능 모의고사  4등급',
    },
    {
      min: 27,
      max: 30,
      level: 'Level 4',
      level_no: 4,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: 'B Type Test 응시 추천',
    },
  ],
  RCB: [
    {
      min: 0,
      max: 9,
      level: 'Level 4',
      level_no: 4,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: '고1 수능 모의고사  3등급',
    },
    {
      min: 10,
      max: 16,
      level: 'Level 5',
      level_no: 5,
      lexile: '800L ~ 900L',
      grade: '고1 ( 2등급 )',
      comment: '고1 수능 모의고사  2등급',
    },
    {
      min: 17,
      max: 20,
      level: 'Level 6',
      level_no: 6,
      lexile: '850L ~ 950L',
      grade: '고1 ( 1등급 )',
      comment: '고1 수능 모의고사  1등급',
    },
    {
      min: 21,
      max: 24,
      level: 'Level 7',
      level_no: 7,
      lexile: '950L ~ 1,050L',
      grade: '고2 ( 3등급 )',
      comment: '고2 수능 모의고사  3~4등급',
    },
    {
      min: 25,
      max: 27,
      level: 'Level 8',
      level_no: 8,
      lexile: '1,000L ~ 1,100L',
      grade: '고2 ( 2등급 )',
      comment: '고2 수능 모의고사  2등급',
    },
    {
      min: 28,
      max: 30,
      level: 'Level 9',
      level_no: 9,
      lexile: '1,100L ~ 1,200L',
      grade: '고2 ( 1등급 )',
      comment: '고2 수능 모의고사  1등급 이상 수준 / 실전 수능 레벨 판정 불가',
    },
  ],
  GRA: [
    {
      min: 0,
      max: 9,
      level: 'Prep 3',
      level_no: 0,
      lexile: '400L ~ 500L',
      grade: '내신 ( 중1 )',
      comment: '중1 교과서 수준 읽고 이해 / 과거 시제까지',
    },
    {
      min: 10,
      max: 16,
      level: 'Level 1',
      level_no: 1,
      lexile: '450L ~ 550L',
      grade: '내신 ( 중2 )',
      comment: '중2 교과서 수준 읽고 이해 / 관계 절 까지',
    },
    {
      min: 17,
      max: 22,
      level: 'Level 2',
      level_no: 2,
      lexile: '550L ~ 650L',
      grade: '내신 ( 중3 )',
      comment: '중3 교과서 수준 읽고 이해 / 중등 문법 전체',
    },
    {
      min: 23,
      max: 26,
      level: 'Level 3',
      level_no: 3,
      lexile: '650L ~ 750L',
      grade: '내신 ( 중3 [상] )',
      comment: '고1 수능 모의고사  4등급',
    },
    {
      min: 27,
      max: 30,
      level: 'Level 4',
      level_no: 4,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: 'B Type Test 응시 추천',
    },
  ],
  GRB: [
    {
      min: 0,
      max: 9,
      level: 'Level 4',
      level_no: 4,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: '고1 수능 모의고사  3등급',
    },
    {
      min: 10,
      max: 16,
      level: 'Level 5',
      level_no: 5,
      lexile: '800L ~ 900L',
      grade: '고1 ( 2등급 )',
      comment: '고1 수능 모의고사  2등급',
    },
    {
      min: 17,
      max: 20,
      level: 'Level 6',
      level_no: 6,
      lexile: '850L ~ 950L',
      grade: '고1 ( 1등급 )',
      comment: '고1 수능 모의고사  1등급',
    },
    {
      min: 21,
      max: 24,
      level: 'Level 7',
      level_no: 7,
      lexile: '950L ~ 1,050L',
      grade: '고2 ( 3등급 )',
      comment: '고2 수능 모의고사  3~4등급',
    },
    {
      min: 25,
      max: 27,
      level: 'Level 8',
      level_no: 8,
      lexile: '1,000L ~ 1,100L',
      grade: '고2 ( 2등급 )',
      comment: '고2 수능 모의고사  2등급',
    },
    {
      min: 28,
      max: 30,
      level: 'Level 9',
      level_no: 9,
      lexile: '1,100L ~ 1,200L',
      grade: '고2 ( 1등급 )',
      comment: '고2 수능 모의고사  1등급 이상 수준 / 실전 수능 레벨 판정 불가',
    },
  ],
  RCJVA: [
    {
      min: 0,
      max: 10,
      level: 'Level 1',
      level_no: 1,
      lexile: '400L ~ 500L',
      grade: '내신 ( 중1 )',
      comment: '중1 교과서 수준 읽고 이해 / 과거 시제까지',
    },
    {
      min: 11,
      max: 20,
      level: 'Level 2',
      level_no: 2,
      lexile: '450L ~ 550L',
      grade: '내신 ( 중2 )',
      comment: '중2 교과서 수준 읽고 이해 / 관계 절 까지',
    },
    {
      min: 21,
      max: 30,
      level: 'Level 3',
      level_no: 3,
      lexile: '550L ~ 650L',
      grade: '내신 ( 중3 )',
      comment: '중3 교과서 수준 읽고 이해 / 중등 문법 전체',
    },
    {
      min: 31,
      max: 40,
      level: 'Level 4',
      level_no: 4,
      lexile: '650L ~ 750L',
      grade: '내신 ( 중3 [상] )',
      comment: '고1 수능 모의고사  4등급',
    },
    {
      min: 41,
      max: 50,
      level: 'Level 5',
      level_no: 5,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: 'B Type Test 응시 추천',
    },
  ],
  RCJVB: [
    {
      min: 0,
      max: 10,
      level: 'Level 6',
      level_no: 6,
      lexile: '400L ~ 500L',
      grade: '내신 ( 중1 )',
      comment: '중1 교과서 수준 읽고 이해 / 과거 시제까지',
    },
    {
      min: 11,
      max: 20,
      level: 'Level 7',
      level_no: 7,
      lexile: '450L ~ 550L',
      grade: '내신 ( 중2 )',
      comment: '중2 교과서 수준 읽고 이해 / 관계 절 까지',
    },
    {
      min: 21,
      max: 30,
      level: 'Level 8',
      level_no: 8,
      lexile: '550L ~ 650L',
      grade: '내신 ( 중3 )',
      comment: '중3 교과서 수준 읽고 이해 / 중등 문법 전체',
    },
    {
      min: 31,
      max: 40,
      level: 'Level 9',
      level_no: 9,
      lexile: '650L ~ 750L',
      grade: '내신 ( 중3 [상] )',
      comment: '고1 수능 모의고사  4등급',
    },
    {
      min: 41,
      max: 50,
      level: 'Level 10',
      level_no: 10,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: 'B Type Test 응시 추천',
    },
  ],
  RCJVC: [
    {
      min: 0,
      max: 10,
      level: 'Level 11',
      level_no: 11,
      lexile: '400L ~ 500L',
      grade: '내신 ( 중1 )',
      comment: '중1 교과서 수준 읽고 이해 / 과거 시제까지',
    },
    {
      min: 11,
      max: 20,
      level: 'Level 12',
      level_no: 12,
      lexile: '450L ~ 550L',
      grade: '내신 ( 중2 )',
      comment: '중2 교과서 수준 읽고 이해 / 관계 절 까지',
    },
    {
      min: 21,
      max: 30,
      level: 'Level 13',
      level_no: 13,
      lexile: '550L ~ 650L',
      grade: '내신 ( 중3 )',
      comment: '중3 교과서 수준 읽고 이해 / 중등 문법 전체',
    },
    {
      min: 31,
      max: 40,
      level: 'Level 14',
      level_no: 14,
      lexile: '650L ~ 750L',
      grade: '내신 ( 중3 [상] )',
      comment: '고1 수능 모의고사  4등급',
    },
    {
      min: 41,
      max: 50,
      level: 'Level 15',
      level_no: 15,
      lexile: '700L ~ 800L',
      grade: '고1 ( 3등급 )',
      comment: 'B Type Test 응시 추천',
    },
  ],
};

export const BOOK_REPORT_DEFAULT_FILL = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

Student's original writing:
"((topic))"

▶ In "My Writing", first determine whether the student's writing contains any violations of the seven checklist categories.

If there are NO violations:
- Display the student's entire original writing exactly as it is.
- Do NOT use strikethrough, bold, or italics.
- Zero errors is a valid result.

If there ARE violations:
- Mark ONLY the parts that clearly violate one of the six checklist categories.
- For each detected error, strike through the exact incorrect part and immediately present the corrected form in bold italics.
- Do NOT mark anything that is grammatically acceptable in standard English.
- Do NOT revise for naturalness, word preference, or style.

▶ When detecting errors, use ONLY this checklist as your criteria:
1. Capitalization
2. Subject-Verb Agreement
3. Singular and Plural Nouns
4. Spelling Errors
5. Other Grammatical Errors (tense, prepositions, articles)
6. Sentence Structure, punctuation, and spacing
7. Terminal punctuation: Inspect every non-empty line independently; every complete declarative sentence must end with ".", "!", or "?", every direct question must end with "?", and a missing terminal mark is a separate error even if the same line has another error; insert the missing mark in bold italics without strikethrough.

Important restriction:
If no checklist rule is violated, show the original writing as it is without using any format.

Do not fabricate or reinterpret correct phrases as errors.

This is strictly an error-detection task based only on the seven criteria.

▶ In 'Corrections', display the student's entire writing again,
but apply bold italics ONLY to the corrected forms that were already shown in "My Writing."

- Do NOT introduce any new corrections.
- Do NOT modify sentence structure.
- Use exactly the same corrected forms that appeared in "My Writing."
- This section must correspond exactly to the corrections shown above.

If no errors are found, show the original writing as it is without using any format.

▶ In "Explanation", list ONLY the actual errors found in the student's original writing as a numbered list.  
Include only items where a checklist violation occurred.  
Do NOT mention sentences that have no errors.  
Do NOT state that a sentence is correct.  

The "Explanation" section MUST correspond exactly to the errors marked in "My Writing."  
- Only describe errors that were visibly marked in "My Writing."  
- Do NOT introduce new corrections that were not marked above.  
- The number of listed errors must match the number of corrections shown in "My Writing."  

▶ In 'Korean Explanation', Translate exactly the same content from the "Explanation".

▶ In 'Total Error Count', Display only the total number of errors you corrected.
Display only the total number of errors you corrected. 
If there are no errors, write: Total error count: 0

---

Show the result in this format:

## Check

### My Writing
(Display the original writing with any detected error words. For each detected error word, strike through the exact incorrect word and immediately present the corrected form in bold italics. When there's no error, show the original writing as it is without using any format.)

example: ~~presant~~ ***present***

example (no error): present

---

### Corrections
(Show the student's entire writing again.
Apply bold italics ONLY to the exact corrected forms that were already shown in "My Writing."
Do NOT introduce any new corrections.
Do NOT modify wording, sentence structure, or style.
This section must correspond exactly to the corrections shown in "My Writing."
If no errors are found, show the original writing as it is without using any format.)

example: ***present***

example (no error): present

---

### Explanation
(List ONLY the errors that were already marked in "My Writing" as a numbered list.
Do NOT re-analyze the text.
Do NOT introduce new corrections.
The number of items must exactly match the number of corrections shown in "My Writing."
If none were marked above, write "No errors found." without a numbered list.)

### Korean Explanation
(Exact translation of Explanation)

---

### Total Error Count
Total error count: ()`;

export const BOOK_REPORT_DEFAULT_FILL_W = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

Student's original writing:
"((topic))"

▶ In "Corrections", first determine whether the student's writing contains any violations of the seven checklist categories.

If there are NO violations:
- Display the student's entire original writing exactly as it is.
- Do NOT use strikethrough, bold, or italics.
- Zero errors is a valid result.

If there ARE violations:
- Mark ONLY the parts that clearly violate one of the six checklist categories.
- For each detected error, strike through the exact incorrect part and immediately present the corrected form in bold italics.
- Do NOT mark anything that is grammatically acceptable in standard English.
- Do NOT revise for naturalness, word preference, or style.

▶ When detecting errors, use ONLY this checklist as your criteria:
1. Capitalization
2. Subject-Verb Agreement
3. Singular and Plural Nouns
4. Spelling Errors
5. Other Grammatical Errors (tense, prepositions, articles)
6. Sentence Structure, punctuation, and spacing
7. Terminal punctuation: Inspect every non-empty line independently; every complete declarative sentence must end with ".", "!", or "?", every direct question must end with "?", and a missing terminal mark is a separate error even if the same line has another error; insert the missing mark in bold italics without strikethrough.

Important restriction:
If no checklist rule is violated, show the original writing as it is without using any format.

Do not fabricate or reinterpret correct phrases as errors.

This is strictly an error-detection task based only on the seven criteria.

▶ In "Explanation", list ONLY the actual errors found in the student's original writing as a numbered list.  
Include only items where a checklist violation occurred.  
Do NOT mention sentences that have no errors.  
Do NOT state that a sentence is correct.  

The "Explanation" section MUST correspond exactly to the errors marked in "My Writing."  
- Only describe errors that were visibly marked in "My Writing."  
- Do NOT introduce new corrections that were not marked above.  
- The number of listed errors must match the number of corrections shown in "My Writing."  

▶ In 'Korean Explanation', Translate exactly the same content from the "Explanation".

▶ In 'Total Error Count', Display only the total number of errors you corrected.
Display only the total number of errors you corrected. 
If there are no errors, write: Total error count: 0

---

Show the result in this format:

## Check

### Corrections
(Display the original writing with any detected error words. For each detected error word, strike through the exact incorrect word and immediately present the corrected form in bold italics. When there's no error, show the original writing as it is without using any format.)

example: ~~presant~~ ***present***

example (no error): present

---

### Explanation
(List ONLY the errors that were already marked in "My Writing" as a numbered list.
Do NOT re-analyze the text.
Do NOT introduce new corrections.
The number of items must exactly match the number of corrections shown in "My Writing."
If none were marked above, write "No errors found." without a numbered list.)

### Korean Explanation
(Exact translation of Explanation)

---

### Total Error Count
Total error count: ()`;

export const BOOK_REPORT_REVISE_FILL = `Rewrite the student's writing as a polished model paragraph.

- Keep the original main ideas.
- Correct all grammatical errors.
- Improve sentence flow, clarity, and organization.
- Enhance the writing so it reads like a strong model example.
- Use clear and natural vocabulary appropriate for an intermediate level.
- You may combine, split, or restructure sentences to improve quality.
- Do NOT explain the corrections.
- Show only the revised model writing.

Use natural paragraph formatting.
You may keep it as one paragraph or divide it into two short paragraphs if it improves clarity and flow.
Avoid placing each sentence on a separate line.

Student Writing:
"((topic))"`;

export const BOOK_REPORT_CHECK_FILL = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

Student's original writing:
"((topic))"

▶ In "My Writing", first determine whether the student's writing contains any violations of the six checklist categories.

If there are NO violations:
- Display the student's entire original writing exactly as it is.
- Do NOT use strikethrough, bold, or italics.
- Zero errors is a valid result.

If there ARE violations:
- Mark ONLY the parts that clearly violate one of the six checklist categories.
- For each detected error, strike through the exact incorrect part and immediately present the corrected form in bold italics.
- Do NOT mark anything that is grammatically acceptable in standard English.
- Do NOT revise for naturalness, word preference, or style.

▶ When detecting errors, use ONLY this checklist as your criteria:
1. Capitalization
2. Subject-Verb Agreement
3. Singular and Plural Nouns
4. Spelling Errors
5. Other Grammatical Errors (tense, prepositions, articles)
6. Sentence Structure, punctuation, and spacing

Important restriction:
If no checklist rule is violated, show the original writing as it is without using any format.

Do not fabricate or reinterpret correct phrases as errors.

This is strictly an error-detection task based only on the six criteria.

▶ In 'Corrections', display the student's entire writing again,
but apply bold italics ONLY to the corrected forms that were already shown in "My Writing."

- Do NOT introduce any new corrections.
- Do NOT modify sentence structure.
- Use exactly the same corrected forms that appeared in "My Writing."
- This section must correspond exactly to the corrections shown above.

If no errors are found, show the original writing as it is without using any format.

▶ In "Explanation", list ONLY the actual errors found in the student's original writing as a numbered list.  
Include only items where a checklist violation occurred.  
Do NOT mention sentences that have no errors.  
Do NOT state that a sentence is correct.  

The "Explanation" section MUST correspond exactly to the errors marked in "My Writing."  
- Only describe errors that were visibly marked in "My Writing."  
- Do NOT introduce new corrections that were not marked above.  
- The number of listed errors must match the number of corrections shown in "My Writing."  

If no errors are found, write: "No errors found."

▶ In 'Korean Explanation', Translate exactly the same content from the "Explanation".

▶ In 'Total Error Count', Display only the total number of errors you corrected.
Display only the total number of errors you corrected. 
If there are no errors, write: Total error count: 0

---

Show the result in this format:

## Check

### My Writing
(Display the original writing with any detected error words. For each detected error word, strike through the exact incorrect word and immediately present the corrected form in bold italics. When there's no error, show the original writing as it is without using any format.)

example: ~~presant~~ ***present***

example (no error): present

---

### Corrections
(Show the student's entire writing again.
Apply bold italics ONLY to the exact corrected forms that were already shown in "My Writing."
Do NOT introduce any new corrections.
Do NOT modify wording, sentence structure, or style.
This section must correspond exactly to the corrections shown in "My Writing."
If no errors are found, show the original writing as it is without using any format.)

example: ***present***

example (no error): present

---

### Explanation
(List ONLY the errors that were already marked in "My Writing" as a numbered list.
Do NOT re-analyze the text.
Do NOT introduce new corrections.
The number of items must exactly match the number of corrections shown in "My Writing."
If none were marked above, write "No errors found." without a numbered list.)

### Korean Explanation
(Exact translation of Explanation)

---

### Total Error Count
Total error count: ()`;

export const BOOK_REPORT_WORD = `Define the word "((word))" with the part of speech and definitions if there are more than one in English and in Korean in ((level)). 
Explain the definition in Korean with part of speech and give me synonyms and 
give 2 example sentences in English and Korean in the format of 
"The Word:", 
"Meaning:", 
"Korean Meaning: ", 
"Sentence(1):", 
"Translation in Korean:",
"Sentence(2):", 
"Translation in Korean:",
"Synonyms".`;

export const BOOK_REPORT_COMMENT_LIST = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

You are going to assess the student's writing based on relevance to the content, quality of the writing, presence of a clear topic sentence, logical coherence, organization, voice employed in the writing, appropriateness of word choice. Also, estimate the Toefl score of this writing in scale of 0 to 30.

Here is the student's original writing:
"((topic))"

---

For all items below, please write one comment composed of a paragraph.
- For Opinion, describe ONLY the student's opinion or personal viewpoint expressed in the writing.
- For Topic / Concluding Sentence, describe ONLY whether the writing has a clear topic sentence and a clear concluding sentence
- For Facts and Logic, describe ONLY how well the student uses facts and logical reasoning to support ideas.
- For Voice, describe ONLY how clearly the student's voice or personal tone appears in the writing.
- For Organization, describe ONLY how well the ideas are organized and logically ordered.
- For Word Choice, describe ONLY the appropriateness and variety of words used in the writing.
- For Strong Points, list ONLY the student's strong points in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Weak Points, list ONLY the student's weak points or areas for improvement in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Suggestions, list ONLY specific and detailed suggestions to enhance the writing in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.

All explanations must be provided in English only.

For structured JSON output fields:
- toefl_feedback_en: exactly ONE sentence, around 15 words.
- total_feedback: concise overall feedback summary.
- enhanced_guidance_en: practical guidance in English.
- enhanced_guidance_ko: exact Korean guidance counterpart.
- strong_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- strong_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- weak_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- weak_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- suggestions_en: English-only bullet items. Do NOT include Korean/Hangul.
- suggestions_ko: Korean-only bullet items. Do NOT include full English sentences.
- Pairing rule: each _en item must have its Korean translation at the same index in the corresponding _ko array.
- Final validation before output: if language is mixed in any list, correct it so _en contains only English and _ko contains only Korean.


---

Please show the result in the following format:

## Feedback

### Opinion

[English - Paragraph: Opinion]

--- 
### Topic / Concluding Sentence

[English - Paragraph: Topic / Concluding Sentence]

--- 

### Facts and Logic

[English - Paragraph: Facts and Logic]

--- 

### Voice

[English - Paragraph: Voice]

--- 

### Organization

[English - Paragraph: Organization]

--- 

### Word Choice

[English - Paragraph: Word Choice]

--- 

### Strong Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Weak Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Suggestions

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### TOEFL Score

[comment sentence in English]
  
()/30`;

export const BOOK_REPORT_COMMENT_LIST_W = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

You are going to assess the student's writing based on relevance to the content, quality of the writing, presence of a clear topic sentence, logical coherence, organization, voice employed in the writing, appropriateness of word choice. 

Here is the student's original writing:
"((topic))"

---

For all items below, please write one comment composed of a paragraph.
- For Ideas / Content, describe ONLY how clearly and effectively the student presents ideas and develops the main content of the writing.
- For Organization / Structure, describe ONLY how well the writing is organized, including the logical order of ideas and the presence of clear structural elements.
- For Voice / Expression, describe ONLY how clearly the student's personal voice, tone, or expression appears in the writing.
- For Word Choice / Vocabulary, describe ONLY the appropriateness and variety of vocabulary used in the writing.
- For Sentence Fluency / Conventions, describe ONLY how smoothly the sentences flow and how accurately the student uses grammar, punctuation, and writing conventions.
- For Strong Points, list ONLY the student's strong points in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Weak Points, list ONLY the student's weak points or areas for improvement in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Suggestions, list ONLY specific and detailed suggestions to enhance the writing in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.

All explanations must be provided in English only.

For structured JSON output fields:
- toefl_feedback_en: exactly ONE sentence, around 15 words.
- total_feedback: concise overall feedback summary.
- enhanced_guidance_en: practical guidance in English.
- enhanced_guidance_ko: exact Korean guidance counterpart.
- strong_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- strong_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- weak_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- weak_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- suggestions_en: English-only bullet items. Do NOT include Korean/Hangul.
- suggestions_ko: Korean-only bullet items. Do NOT include full English sentences.
- Pairing rule: each _en item must have its Korean translation at the same index in the corresponding _ko array.
- Final validation before output: if language is mixed in any list, correct it so _en contains only English and _ko contains only Korean.


---

Please show the result in the following format:

## Feedback

### Ideas / Content

[English - Paragraph: Ideas / Content]

--- 
### Organization / Structure

[English - Paragraph: Organization / Structure]

--- 

### Voice / Expression

[English - Paragraph: Voice / Expression]

--- 

### Word Choice / Vocabulary

[English - Paragraph: Word Choice / Vocabulary]

--- 

### Sentence Fluency / Conventions

[English - Paragraph: Sentence Fluency / Conventions]

--- 

### Strong Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Weak Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Suggestions

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet`;

export const REVIEWSAVE = `NOW, CONVERSATION IS DONE AND USER CLICKED THE "SAVE/FINISH" BUTTON.
NOW, PLEASE GIVE THE FEEDBACK BASED ON OUR CONVERSATION ABOVE! DO NOT ASK FOR CONFIRMATION, DO NOT ASK ANY OTHER QUESTIONS.
NEVER MENTION LIKE "I'm sorry, but I'm unable to provide that kind of detailed evaluation right now" or anything like that. JUST GIVE THE FEEDBACK EXACTLY ACCORDING TO THE "Output Format" BELOW.

# AI–Learner Evaluation Prompt Template (Speaking Version)

This evaluation focuses on how well the learner communicates their ideas in spoken English.

The goal is not perfect grammar, but how effectively the learner conveys meaning, uses appropriate vocabulary, and demonstrates effort in communication.

When scoring, evaluate based on the learner's first attempt before correction.
Do not score based only on the corrected retry response.
The retry response may be considered only as evidence of learning reaction, not as the main scoring basis.

---

## Scoring Criteria

Evaluate the learner based on the following five categories.
Each category should be scored as a percentage (0–100%).

### 1. Content (내용 적합성)
- How relevant and appropriate the response is to the topic or question.

### 2. Delivery (전달력)
- How clearly and smoothly the learner delivers their message.

### 3. Word Choice (어휘 선택)
- The appropriateness and variety of vocabulary used.

### 4. Detailed Explaining (상세 설명 능력)
- The ability to elaborate and provide sufficient details.

### 5. Efforts and Extra Questions (노력 및 추가 질문 응답)
- The learner's effort in responding and engaging, including answering follow-up or extended questions.

---

## Comment Guideline

- Each comment should be written in Korean honorific form.
- Write approximately 2 sentences per category.
- Keep the feedback clear, specific, and supportive.
- Briefly mention both strengths and areas for improvement when possible.

---

## Score Range Mapping

Convert each percentage score into a level using the following scale:

- 90–100: Excellent
- 80–89: Very Good
- 70–79: Good
- 60–69: Fair
- 50–59: Poor
- 0–49: Very Poor

---

## Overall Comment 
For the overall comment, Write one overall comment composed of two paragraphs. Use Korean honorific.

---

## Output Format

### speaking 평가
#### 학생의 Speaking 은 아래 5가지 기준으로 평가하였습니다.
---

1. **Content (내용 적합성)**
   - Score: ( )%
   - Level: 
   - Comment: (write 2 sentences in Korean honorific)

---

2. **Delivery (전달력)**
   - Score: ( )%
   - Level: 
   - Comment: (write 2 sentences in Korean honorific)

---

3. **Word Choice (어휘 선택)**
   - Score: ( )%
   - Level: 
   - Comment: (write 2 sentences in Korean honorific)

---

4. **Detailed Explaining (상세 설명 능력)**
   - Score: ( )%
   - Level: 
   - Comment: (write 2 sentences in Korean honorific)

---

5. **Efforts and Extra Questions (노력 및 추가 질문 응답)**
   - Score: ( )%
   - Level: 
   - Comment: (write 2 sentences in Korean honorific)

---

### Overall comment
(write 2 paragraph in Korean honorific)

---

### 종합 평가 (Overall Result)

- overall level: (very poor/poor/fair/good/very good/excellent)
- 총점 (Total score): ( )/100%`;

export const REVIEW_SAVE_SESSION_INSTRUCTIONS = `# Feedback-only mode
Generate only the final written speaking evaluation requested by the next review-save prompt. This is an internal evaluation report, not a learner-facing conversation turn.

- Follow the review-save prompt and its Output Format exactly.
- The normal lesson conversation-language instruction does not apply to this report.
- Even when the lesson language is English, write every category Comment and the complete Overall comment in natural Korean honorific form.
- The parentheses and blank values shown in the Output Format are placeholders, not literal output. Replace every "Score: ( )%" with an actual integer score from 0 to 100 and fill every blank "Level:" value.
- Map every category score to its Level exactly: 90-100 = Excellent, 80-89 = Very Good, 70-79 = Good, 60-69 = Fair, 50-59 = Poor, and 0-49 = Very Poor.
- Calculate the total score as the rounded arithmetic average of the five category scores. Replace "총점 (Total score): ( )/100%" with that actual integer total and fill the overall level from the same score-range mapping.
- Never return empty parentheses, a missing numeric score, a blank Level, or an unfilled total-score placeholder.
- Preserve the requested heading text, numbering, Score, Level, Comment fields, separators, bold Markdown, paragraph breaks, and final overall result structure, but replace every placeholder with its completed evaluation value.
- Markdown headings are explicitly allowed and required when they appear in the requested Output Format.
- Do not translate, rename, reorder, combine, summarize, or omit any required section.
- Return only the completed evaluation report. Do not ask a question, continue the lesson, call a tool, or add commentary outside the report.`;

export const REVIEWSAVEW = `DO NOT ASK ME FOR CONFIRMATION, GIVE ME THE FEEDBACK ACCORDING TO BELOW.

# AI–Learner Evaluation Prompt Template

You will evaluate a conversation between an AI and a learner.  
Please be gentle when grading. This was spoken by an elementary school student.

---

## Scoring Rubric  
Use this scoring rubric to evaluate the learner's speaking based on how well they respond to the given questions and text.

All evaluation must be based only on the learner's **first spontaneous answer** to each question.  
Do not use any repeated sentences after correction for evaluation.  
The repetition step is for practice, not for assessment.

Do not judge grammar accuracy, pronunciation accuracy, or sentence perfection.

Do not decide a score from only one good answer or one mistake.  
Look at the learner's overall speaking pattern across all questions.

Only score what can be clearly seen in the learner's first spoken responses.  
Do not guess the learner's intention, effort, or hidden ability.

When it is hard to choose between two levels, select the lower one that is safely supported by what the learner actually said.

Each category must be evaluated independently and should not influence the score of other categories.

### 1. Content Fulfillment (과제 내용 충실도)  
Check whether the learner includes the key information required by the lesson topic.  

- **Excellent:** 레슨에서 요구한 내용 요소(대상, 장소, 행동, 경험, 이유 등)를 대부분 빠짐없이 말한다.  
- **Good:** 주요 내용은 포함하지만, 일부 조건이나 세부 요소가 빠져 있다.  
- **Fair:** 내용이 제한적이며, 요구 조건 중 일부만 충족한다.  
- **Needs Support:** 레슨 주제와 맞는 핵심 내용이 거의 나타나지 않는다.   

### 2. Language Structure Use (문법 구조 사용)  
Check whether the learner uses the language structures required in the lesson (tense, patterns, grammar forms).  

- **Excellent:** 레슨에서 요구한 문법 구조를 자연스럽게 여러 번 사용한다.  
- **Good:** 필요한 구조를 사용하지만, 횟수나 정확성이 완전하지는 않다.  
- **Fair:** 힌트가 있어야 구조를 사용하거나 일부만 시도한다.  
- **Needs Support:** 요구된 문법 구조 사용이 거의 나타나지 않는다.  

### 3. Sentence Formation (문장 구성력)  
Check whether the learner forms complete and meaningful sentences.  

- **Excellent:** 대부분의 답을 문장 형태로 말하며 의미 전달이 분명하다.  
- **Good:** 문장과 단어 답이 섞여 있으나 의미 전달은 가능하다.  
- **Fair:** 주로 단어 중심으로 말하며 문장 구성 시도가 적다.  
- **Needs Support:** 문장 형태의 발화가 거의 없다.  

### 4. Topic Understanding & Relevance (주제 이해 및 관련성)  
Check whether the learner's responses stay related to the topic and question.  

- **Excellent:** 항상 질문과 주제에 맞는 내용으로 대답한다.  
- **Good:** 대부분 관련된 답을 하지만, 가끔 벗어난다.  
- **Fair:** 주제와 맞는 답과 벗어난 답이 섞여 있다.  
- **Needs Support:** 질문과 관련 없는 답이 자주 나타난다.   

### 5. Personal Expression & Engagement (자기 표현 및 참여도)  
Check whether the learner expresses personal experience, opinion, feeling, or shows active participation.  

- **Excellent:** 자신의 경험, 생각, 느낌, 선호 등을 적극적으로 표현한다.  
- **Good:** 힌트가 있으면 개인적인 생각이나 반응을 말할 수 있다.  
- **Fair:** 주로 정답 중심 답만 하며 개인 표현이 드물다.  
- **Needs Support:** 자기 생각이나 경험을 말하려는 시도가 거의 없다.

---

## Level Evaluation Rules
Each explanation must be written in one clear sentence that directly describes observable speaking behavior.

DO NOT EVALUATE ASSISTANT'S MESSAGE.

---

## Overall Result Rule

The overall result for each category should be decided by looking at the overall pattern of the four performance levels, not by simple mathematical averaging.

If most of the indicators fall in the same level, use that level as the overall result.

If two levels appear frequently, choose the lower one to stay conservative.

Do not calculate a numeric average.
Use professional judgment based on consistent performance.

In overall comment, put comment in Korean only.

---

## Output Format

### Speaking 평가
#### 학생의 speaking 은 아래의 5가지 기준으로 평가하였습니다.

+ **Content Fulfillment (과제 내용 충실도)**
  - Level: ( )
  - 설명:
  - 학생 답변 예시:

+ **Language Structure Use (문법 구조 사용)**
  - Level: ( )
  - 설명:
  - 학생 답변 예시:

+ **Sentence Formation (문장 구성력)**
  - Level: ( )
  - 설명:
  - 학생 답변 예시:

+ **Topic Understanding & Relevance (주제 이해 및 관련성)**
  - Level: ( )
  - 설명:
  - 학생 답변 예시:

+ **Personal Expression & Engagement (자기 표현 및 참여도)**
  - Level: ( )
  - 설명: 
  - 학생 답변 예시:

---
### Overall Result
- Overall Level: ( )
- Overall comment: 

Do not show anything else but overall comment in the last line.`;

// Rubric prompt templates
export const AUTO_GENERATE_PROMPT = `Give me rubric(ideas,organization,voice,word_choice,conventions) out of 20 with 5 interval and generate toefl score out of 30, overall score out of 20 for this writing "((response))"
Please be gentle when grading. This was written by an elementary school student.
On the very last line, display the total score by adding the overall score to the five rubric scores.
only return score and nothing else and all scores should be returned as #type:score
Example:
#word_choice:5
#conventions:10
#voice:15
#ideas:20
#organization:15
#overall:18

#toefl:20
#total:83`;

export const AUTO_GENERATE_PROMPT_WITH_GRAMMAR = `Give me rubric(ideas,organization,voice,word_choice,conventions) out of 20 with 5 interval and generate toefl score out of 30 for this writing "((response))"

**IMPORTANT - Focus Evaluation:**
This writing was specifically focused on practicing these points:
((grammar_points))

Please be gentle when grading. This was written by an elementary school student.
On the very last line, display the total score by adding the overall score to the five rubric scores.
only return score and nothing else and all scores should be returned as #type:score
Example:
#word_choice:5
#conventions:10
#voice:15
#ideas:20
#organization:15
#overall:18

#toefl:20
#total:83`;

export const RUBRIC_REVISE_PROMPT = `Can you rewrite this writing with very easy words in polite way with smooth transitions
without showing corrections and explanations with the difficulty level of ((level)) "((topic))"?
Translate in English and ((language))`;

export const RUBRIC_REVISE_PROMPT_GRAMMAR = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

You are going to assess the student's writing based on relevance to the content, quality of the writing, presence of a clear topic sentence, logical coherence, organization, voice employed in the writing, appropriateness of word choice.

---

Most important thing is whether its content matches and stays relevant to this content, so if student's answer is not relevant to the content, give the lower score.

This is the content for the student's writing:
"((grammar_points))"

Here is the student's original writing:
"((topic))"

---

Write one overall comment composed of three paragraphs.

- The first paragraph should describe ONLY the student's strong points in writing.
- The second paragraph should describe ONLY the student's weak points or areas for improvement.
- The third paragraph should provide ONLY suggestions for future improvement.

Do NOT use bullet points or lists. Write each paragraph as continuous prose.

After the three English paragraphs, provide the exact same content translated into Korean.
The Korean version should follow the same three-paragraph structure and order.

Please show the result in the following format:

## Overall comment
### This overall comment offers an overview of the student's writing, covering strong points, weak points, and suggestions for improvement.

[English - Paragraph 1: Strong Points]

[English - Paragraph 2: Weak Points]

[English - Paragraph 3: Suggestions]

[Korean - Paragraph 1 Translation]

[Korean - Paragraph 2 Translation]

[Korean - Paragraph 3 Translation]`;

export const RUBRIC_REVISE_PROMPT_W = `I am an ESL English teacher. Please help me carefully evaluate my student's writing by focusing specifically on the following these detailed instructions closely.

▶ In the “Overall Result,” for the “시각적 해석” column, draw a 20-block bar using █ for each point earned and ░ for each missing point, based on the score out of 20.

▶ In the “Overall Result,” for the “total” row in the “시각적 해석” column, display one of the five levels written only in Korean (상위 평균, 상, 중, 하, 기초) according to the total score.

▶ In the “Overall Result” comment, write one sentence in Korean using polite honorific language that focuses on the student's strongest area and summarizes the overall writing performance in a natural and positive way.

▶ the exact text <<<###$#$#$#$#$>>> must remain exactly as written between the “Overall Result” and the “Overall Performance Summary,” and it must not be removed, modified, or replaced.

▶ In the “Overall Score Graph” section of the “Overall Performance Summary,” use the “IB / 미국학교 점수 체계표” to show the IB Writing Score, the US Letter Grade, and the GPA Equivalent.

▶ For the IB Writing Score in the “Overall Score Graph,” draw a 100-block bar using █ for each point earned and ░ for each missing point, based on the score out of 100.

▶ The score shown in the “Overall Score Graph” must be exactly the same as the IB Writing Score.

▶ In the “Overall Performance Summary” comment, mention the student's GPA and explain in one concise sentence in Korean using polite honorific language what level this GPA represents.

▶ In “[1] 영역별 성취도 그래프 (핵심),” display the performance column as a visual graph using a 20-point scale, using █ for each point earned and ░ for each missing point, based on the score out of 20, and show the numeric score immediately to the right of the graph in the format (score)/20.

▶ In the “comment” part of “[1] 영역별 성취도 그래프 (핵심),” use the same comment as the one in the “Overall Performance Summary.”

▶ In the Progress Bar column, visualize performance using a 20-point scale.
Use █ for each point earned and ░ for each missing point, and display one of the following five levels in the Level column: Beginning, Developing, Mid, High, or Very High.

▶ In the “내용” column of “[3] Writing Structure 이해도 그래프,” write a brief explanation in Korean using polite honorific language that describes the student's current performance level.

▶ In the “미국 학년 기준” table, for the 'Writing Level' row, enter the US grade from the “US Grade Level Reference Table” under the column “미국 학년 기준.”

▶ In the “미국 학년 기준” table, for the 'US SChool 기준' row, display “Average” if the GPA Equivalent is 3.0, “Above Average” if it is higher than 3.0, and “Below Average” if it is lower than 3.0.

▶ In the “미국학교 성적 변환 기준 평가표” comment, mention the student's GPA and explain in one concise sentence in Korean using polite honorific language what level this GPA represents and that the current score indicates a stable level for academic performance in a US school.

▶ In the “[5] 강점, 약점 보완 방향” table, write the content for the “핵심 내용” column entirely in Korean using polite honorific language , using one clear and concise sentence for each item.

▶ In the “[6] Next Writing Goals” table, write 2–3 items in Korean using polite honorific language that focus on improving the student's weaknesses. In the “목표” column, write each goal briefly, and in the “구체 행동” column, write one clear sentence describing the specific action needed to achieve that goal.

## 영역별 세부 기준 평가
Each area is checked using only O, △, and X for each sub-criterion, and the final result is shown simply as a total score in the form of (score) / 20.
- Idea / Content
   - 질문 이해: Check whether the student clearly understands and responds to all parts of the given question.
   - 주제 일관성: Check whether the writing stays focused on the main topic without going off-topic.
   - 아이디어 분명함: Check whether the main ideas are clearly stated and easy to understand.
   - 경험·예시 사용: Check whether the student uses personal experiences or examples to support their ideas.
   - 내용 충분성: Check whether there is enough detail and explanation to fully develop the topic.
- Organization / Structure
   - 도입부 존재: Check whether the writing has a clear introduction that presents the topic.
   - Topic Sentence: Check whether each paragraph begins with a topic sentence that shows its main idea.
   - 문단 순서: Check whether paragraphs are arranged in a logical and meaningful order.
   - 문단 연결: Check whether transitions are used to smoothly connect ideas between paragraphs.
   - 결론 마무리: Check whether the writing ends with a conclusion that summarizes or wraps up the main ideas.
- Sentence / Language
   - 문장 완결성: Check whether sentences are complete and not fragments or run-ons.
   - 의미 전달: Check whether sentences clearly convey the intended meaning.
   - 단·복문 균형: Check whether the student uses a balance of simple and more complex sentences.
   - 시제 일관성: Check whether verb tenses are used consistently and appropriately throughout the writing.
- Vocabulary
   - 학년 적합성: Check whether the vocabulary level is appropriate for the student's grade.
   - 정확한 사용: Check whether words are used accurately and fit the context.
   - 반복 표현: Check whether unnecessary repetition of the same words or expressions is avoided.
   - 표현 다양성: Check whether a variety of words and expressions are used to enrich the writing.
- Convention
   - 철자: Check whether words are spelled correctly.
   - 문법: Check whether grammatical structures are used correctly.
   - 대문자, 구두점: Check whether capitalization and punctuation are used properly.

## Writing structure 이해도 평가
Check each of the items below and evaluate them using one of the five levels: Beginning, Developing, Mid, High, or Very High.
- Introduction
  - Check whether the introduction clearly introduces the topic and prepares the reader for what the writing will be about.
- Thesis / Topic
  - Check whether the main idea or central topic of the writing is clear and focused.
- Supporting ideas
  - Check whether reasons, explanations, or examples are sufficient to support the main idea.
- Body Organization
  - Check whether the body of the writing is well organized and logically structured.

## 미국 학년 기준 수준표
| writing 특징        | IB Performance Level | 미국 학년 기준  | 평가 설명                |
|-------------------|---------------------|---------------|------------------------|
| 문장 나열 중심      | Beginning           | Grade K–1     | 생각은 있으나 연결 부족     |
| 기본 문단 형성      | Developing           | Grade 2–3     | 문단 개념 형성             |
| 구조 있는 글        | Mid                 | Grade 4–5     | 서론, 본론, 결론 인식       |
| 논리적 전개         | High                | Grade 6–8     | 이유, 근거 중심            |
| 설득, 분석          | Very High           | Academic Writing | 설득과 분석 중심의 글쓰기 |


## IB / 미국학교 점수 체계표
| IB Score Range | IB Performance Level | US Letter Grade | GPA Equivalent|
|---------------|----------------------|------------------|-----|
| 90%–100%      | Very High             | A                | 4.0 |
| 80%–89%       | High                  | B+               | 3.3 |
| 70%–79%       | Mid                   | B                | 3.0 |
| 60%–69%       | Developing            | C+               | 2.3 |
| 0%–59%        | Beginning             | C                | 2.0 |

---
Here's the student writing:

((student_writing_text))

---
Show the result in following format:
---

### Overall Result
| 평가영역               | 점수      | 시각적 해석                     |
|----------------------|-----------|--------------------------------|
| Ideas (내용)         | (   )/20  | [████████████████████]         |
| Organization (구성)  | (   )/20  | [████████████████████]         |
| Voice (표현/느낌)    | (   )/20  | [████████████████████]         |
| Word Choice (어휘)   | (   )/20  | [████████████████████]         |
| Conventions (문법)   | (   )/20  | [████████████████████]         |
| total                | (   )/100 |                                |

Comment: 

---

<<<###$#$#$#$#$>>>

---

## 평가 상세 페이지
### Overall Performance Summary

- Overall Score Graph  
[████████████████████] ( )/100

| 기준              | 결과        |
|------------------|-------------|
| IB Writing Score | (   ) / 100 |
| US Letter Grade  |             |
| GPA Equivalent   | (   ) / 4.0 |

* GPA 설명: GPA는 미국 학교 성적 지표이며, 4.0이 만점입니다.
* comment: 

---

### [1] 영역별 성취도 그래프 (핵심)
| Category                  | Performance                  |
|--------------------------|------------------------------|
| Ideas / Content           | [████████████████████] ( )/20      |
| Organization / Structure  | [████████████████████] ( )/20      |
| Sentence / Language       | [████████████████████] ( )/20      |
| Vocabulary                | [████████████████████] ( )/20      |
| Convention                | [████████████████████] ( )/20      |

* comment: 

---

### [2] 영역별 평가 항목 + 점수표

#### ► Idea / Content (내용)
| 평가 항목        | 체크 (O / △ / X) |
|----------------|------------------|
| 질문 이해        |                  |
| 주제 일관성      |                  |
| 아이디어 분명함  |                  |
| 경험·예시 사용   |                  |
| 내용 충분성      |                  |
| Score           |   ( )/20         |

#### ► Organization / Structure (구성)
| 평가 항목        | 체크 (O / △ / X) |
|----------------|------------------|
| 도입부 존재      |                  |
| Topic Sentence |                  |
| 문단 순서        |                  |
| 문단 연결        |                  |
| 결론 마무리      |                  |
| Score           |   ( )/20         |

#### ► Sentence / Language (문장력)
| 평가 항목        | 체크 (O / △ / X) |
|----------------|------------------|
| 문장 완결성      |                  |
| 의미 전달        |                  |
| 단·복문 균형     |                  |
| 시제 일관성      |                  |
| Score           |   ( )/20         |

#### ► Vocabulary (어휘)
| 평가 항목    | 체크 (O / △ / X) |
|------------|------------------|
| 학년 적합성  |                  |
| 정확한 사용  |                  |
| 반복 표현    |                  |
| 표현 다양성  |                  |
| Score       |   ( )/20         |

#### ► Conventions (문법·철자)
| 평가 항목        | 체크 (O / △ / X) |
|----------------|------------------|
| 철자            |                  |
| 문법            |                  |
| 대문자, 구두점   |                  |
| Score           |   ( )/20         |

---

### [3] Writing Structure 이해도 그래프
The following section is a diagnostic analysis of writing structure and is not included in the total score.

#### Writing Structure 진단평가표
| Criteria           | Progress Bar              | Level        | 내용 |
|-------------------|---------------------------|--------------|------|
| Introduction      | [████████████████████]    |              |      |
| Thesis / Topic    | [████████████████████]    |              |      |
| Supporting Ideas  | [████████████████████]    |              |      |
| Body Organization | [████████████████████]    |              |      |
| Conclusion        | [████████████████████]    |              |      |

* comment: (One sentence in Korean)

---

### [4] 미국 학년 기준 &TOEFL 환산기준평가표

#### 미국 학년 기준
| 항목            | 내용 |
|----------------|------|
| Writing Level  |      |
| US School 기준 |      |

#### 미국학교 성적 변환 기준 평가표
| 항목            | 결과 |
|----------------|------|
| US Letter Grade|      |
| GPA Equivalent |      |
- comment: 

#### TOEFL Writing 환산
| IB Writing  | TOEFL Writing |
|-------------|---------------|
| (   ) / 100 | (   ) / 30    |

---

### [5] 강점, 약점 보완 방향
| 구분      | 핵심 내용 |
|----------|-----------|
| 강점      |           |
| 약점      |           |
| 보완 방향 |           |

---

### [6] Next Writing Goals
| 목표 | 구체 행동 |
|------|-----------|
|      |           |


---

### Teacher's overall comment
(Give an overall comment in 2 sentences, written in English.)
1. 
2. `;

// AI Writing Grammar-Specific Check Prompt
export const AI_WRITING_GRAMMAR_CHECK_PROMPT = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

Content for the student's writing:
"((grammar_points))"

Student's original writing:
"((topic))"

▶ In "My Writing", first determine whether the student's writing contains any violations of the seven checklist categories.

If there are NO violations:
- Display the student's entire original writing exactly as it is.
- Do NOT use strikethrough, bold, or italics.
- Zero errors is a valid result.

If there ARE violations:
- Mark ONLY the parts that clearly violate one of the six checklist categories.
- For each detected error, strike through the exact incorrect part and immediately present the corrected form in bold italics.
- Do NOT mark anything that is grammatically acceptable in standard English.
- Do NOT revise for naturalness, word preference, or style.

▶ When detecting errors, use ONLY this checklist as your criteria:
1. Capitalization
2. Subject-Verb Agreement
3. Singular and Plural Nouns
4. Spelling Errors
5. Other Grammatical Errors (tense, prepositions, articles)
6. Sentence Structure, punctuation, and spacing
7. Terminal punctuation: Inspect every non-empty line independently; every complete declarative sentence must end with ".", "!", or "?", every direct question must end with "?", and a missing terminal mark is a separate error even if the same line has another error; insert the missing mark in bold italics without strikethrough.

Important restriction:
If no checklist rule is violated, show the original writing as it is without using any format.

Do not fabricate or reinterpret correct phrases as errors.

This is strictly an error-detection task based only on the seven criteria.

▶ In 'Content Evaluation', Briefly explain how well the writing matches the given content in English, then translate it into Korean.

Primary Focus for Content Evaluation:
Most important thing is whether its content matches and stays relevant to this content, so if student's answer is not relevant to the content, give the lower score.

▶ In 'Corrections', display the student's entire writing again,
but apply bold italics ONLY to the corrected forms that were already shown in "My Writing."

- Do NOT introduce any new corrections.
- Do NOT modify sentence structure.
- Use exactly the same corrected forms that appeared in "My Writing."
- This section must correspond exactly to the corrections shown above.

If no errors are found, show the original writing as it is without using any format.

▶ In "Explanation", list ONLY the actual errors found in the student's original writing as a numbered list.  
Include only items where a checklist violation occurred.  
Do NOT mention sentences that have no errors.  
Do NOT state that a sentence is correct.  

The "Explanation" section MUST correspond exactly to the errors marked in "My Writing."  
- Only describe errors that were visibly marked in "My Writing."  
- Do NOT introduce new corrections that were not marked above.  
- The number of listed errors must match the number of corrections shown in "My Writing."  

▶ In 'Korean Explanation', Translate exactly the same content from the "Explanation".

▶ In 'Total Error Count', Display only the total number of errors you corrected.
Display only the total number of errors you corrected. 
If there are no errors, write: Total error count: 0

---

Show the result in this format:

## Check

### My Writing
(Display the original writing with any detected error words. For each detected error word, strike through the exact incorrect word and immediately present the corrected form in bold italics. When there's no error, show the original writing as it is without using any format.)

example: ~~presant~~ ***present***

example (no error): present

---

### Content Evaluation
- EN: (Brief evaluation)
- KR: (translate in polite and respectful honorific Korean)

---

### Corrections
(Show the student's entire writing again.
Apply bold italics ONLY to the exact corrected forms that were already shown in "My Writing."
Do NOT introduce any new corrections.
Do NOT modify wording, sentence structure, or style.
This section must correspond exactly to the corrections shown in "My Writing."
If no errors are found, show the original writing as it is without using any format.)

example: ***present***

example (no error): present

---

### Explanation
(List ONLY the errors that were already marked in "My Writing" as a numbered list.
Do NOT re-analyze the text.
Do NOT introduce new corrections.
The number of items must exactly match the number of corrections shown in "My Writing."
If none were marked above, write "No errors found." without a numbered list.)

### Korean Explanation
(Exact translation of Explanation)

---

### Total Error Count
Total error count: ()

---

### Total Score
total score: ()/100`;

export const AI_WRITING_GRAMMAR_CHECK_PROMPT_W = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

Content for the student's writing:
"((grammar_points))"

Student's original writing:
"((topic))"

▶ In "My Writing", first determine whether the student's writing contains any violations of the seven checklist categories.

If there are NO violations:
- Display the student's entire original writing exactly as it is.
- Do NOT use strikethrough, bold, or italics.
- Zero errors is a valid result.

If there ARE violations:
- Mark ONLY the parts that clearly violate one of the six checklist categories.
- For each detected error, strike through the exact incorrect part and immediately present the corrected form in bold italics.
- Do NOT mark anything that is grammatically acceptable in standard English.
- Do NOT revise for naturalness, word preference, or style.

▶ When detecting errors, use ONLY this checklist as your criteria:
1. Capitalization
2. Subject-Verb Agreement
3. Singular and Plural Nouns
4. Spelling Errors
5. Other Grammatical Errors (tense, prepositions, articles)
6. Sentence Structure, punctuation, and spacing
7. Terminal punctuation: Inspect every non-empty line independently; every complete declarative sentence must end with ".", "!", or "?", every direct question must end with "?", and a missing terminal mark is a separate error even if the same line has another error; insert the missing mark in bold italics without strikethrough.

Important restriction:
If no checklist rule is violated, show the original writing as it is without using any format.

Do not fabricate or reinterpret correct phrases as errors.

This is strictly an error-detection task based only on the seven criteria.

▶ In 'Content Evaluation', Briefly explain how well the writing matches the given content in English, then translate it into Korean.

Primary Focus for Content Evaluation:
Most important thing is whether its content matches and stays relevant to this content, so if student's answer is not relevant to the content, give the lower score.

▶ In "Explanation", list ONLY the actual errors found in the student's original writing as a numbered list.  
Include only items where a checklist violation occurred.  
Do NOT mention sentences that have no errors.  
Do NOT state that a sentence is correct.  

The "Explanation" section MUST correspond exactly to the errors marked in "My Writing."  
- Only describe errors that were visibly marked in "My Writing."  
- Do NOT introduce new corrections that were not marked above.  
- The number of listed errors must match the number of corrections shown in "My Writing."  

▶ In 'Korean Explanation', Translate exactly the same content from the "Explanation".

▶ In 'Total Error Count', Display only the total number of errors you corrected.
Display only the total number of errors you corrected. 
If there are no errors, write: Total error count: 0

---

Show the result in this format:

## Check

### My Writing
(Display the original writing with any detected error words. For each detected error word, strike through the exact incorrect word and immediately present the corrected form in bold italics. When there's no error, show the original writing as it is without using any format.)

example: ~~presant~~ ***present***

example (no error): present

---

### Content Evaluation
- EN: (Brief evaluation)
- KR: (translate in polite and respectful honorific Korean)

---

### Explanation
(List ONLY the errors that were already marked in "My Writing" as a numbered list.
Do NOT re-analyze the text.
Do NOT introduce new corrections.
The number of items must exactly match the number of corrections shown in "My Writing."
If none were marked above, write "No errors found." without a numbered list.)

### Korean Explanation
(Exact translation of Explanation)

---

### Total Error Count
Total error count: ()

---

### Total Score
total score: ()/100`;

export const AI_WRITING_GRAMMAR_COMMENT_PROMPT = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

You are going to assess the student's writing based on relevance to the content, quality of the writing, presence of a clear topic sentence, logical coherence, organization, voice employed in the writing, appropriateness of word choice. Also, estimate the Toefl score of this writing in scale of 0 to 30.

---

Most important thing is whether its content matches and stays relevant to this content, so if student's answer is not relevant to the content, give the lower score.

This is the content for the student's writing:
"((grammar_points))"

Here is the student's original writing:
"((topic))"

---

For all items below, please write one comment composed of a paragraph.
- For Opinion, describe ONLY whether the student's opinion or personal viewpoint is clearly expressed and whether it stays relevant to the given topic.
- For Topic / Concluding Sentence, describe ONLY whether the writing has a clear topic sentence and a clear concluding sentence.
- For Facts and Logic, describe ONLY how well the student uses facts and logical reasoning to support ideas.
- For Voice, describe ONLY how clearly the student's voice or personal tone appears in the writing.
- For Organization, describe ONLY how well the ideas are organized and logically ordered.
- For Word Choice, describe ONLY the appropriateness and variety of words used in the writing.
- For Strong Points, list ONLY the student's strong points in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Weak Points, list ONLY the student's weak points or areas for improvement in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Suggestions, list ONLY specific and detailed suggestions to enhance the writing in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.

All explanations must be provided in English only.

For structured JSON output fields:
- toefl_feedback_en: exactly ONE sentence, around 15 words.
- total_feedback: concise overall feedback summary.
- enhanced_guidance_en: practical guidance in English.
- enhanced_guidance_ko: exact Korean guidance counterpart.
- strong_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- strong_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- weak_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- weak_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- suggestions_en: English-only bullet items. Do NOT include Korean/Hangul.
- suggestions_ko: Korean-only bullet items. Do NOT include full English sentences.
- Pairing rule: each _en item must have its Korean translation at the same index in the corresponding _ko array.
- Final validation before output: if language is mixed in any list, correct it so _en contains only English and _ko contains only Korean.


---

Please show the result in the following format:

## Feedback

### Opinion

[English - Paragraph: Opinion]

--- 
### Topic / Concluding Sentence

[English - Paragraph: Topic / Concluding Sentence]

--- 

### Facts and Logic

[English - Paragraph: Facts and Logic]

--- 

### Voice

[English - Paragraph: Voice]

--- 

### Organization

[English - Paragraph: Organization]

--- 

### Word Choice

[English - Paragraph: Word Choice]

--- 

### Strong Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Weak Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Suggestions

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### TOEFL Score

[comment sentence in English]
  
()/30`;

export const AI_WRITING_GRAMMAR_COMMENT_PROMPT_W = `As an English teacher responsible for revising and providing feedback on essay assignments, I kindly request your assistance in evaluating this piece of writing.

You are going to assess the student's writing based on relevance to the content, quality of the writing, presence of a clear topic sentence, logical coherence, organization, voice employed in the writing, appropriateness of word choice. Also, estimate the Toefl score of this writing in scale of 0 to 30.

---

Most important thing is whether its content matches and stays relevant to this content, so if student's answer is not relevant to the content, give the lower score.

"((grammar_points))"

Here is the student's original writing:
"((topic))"

---

For all items below, please write one comment composed of a paragraph.
- For Ideas / Content, describe ONLY whether the student's writing clearly addresses the given topic and stays relevant to the content, and how effectively the student presents ideas and develops the main content of the writing.
- For Organization / Structure, describe ONLY how well the writing is organized, including the logical order of ideas and the presence of clear structural elements.
- For Voice / Expression, describe ONLY how clearly the student's personal voice, tone, or expression appears in the writing.
- For Word Choice / Vocabulary, describe ONLY the appropriateness and variety of vocabulary used in the writing.
- For Sentence Fluency / Conventions, describe ONLY how smoothly the sentences flow and how accurately the student uses grammar, punctuation, and writing conventions.
- For Strong Points, list ONLY the student's strong points in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Weak Points, list ONLY the student's weak points or areas for improvement in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.
- For Suggestions, list ONLY specific and detailed suggestions to enhance the writing in bullet points, then provide the Korean translation in bullet points written in polite and respectful honorific Korean.

All explanations must be provided in English only.

For structured JSON output fields:
- toefl_feedback_en: exactly ONE sentence, around 15 words.
- total_feedback: concise overall feedback summary.
- enhanced_guidance_en: practical guidance in English.
- enhanced_guidance_ko: exact Korean guidance counterpart.
- strong_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- strong_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- weak_points_en: English-only bullet items. Do NOT include Korean/Hangul.
- weak_points_ko: Korean-only bullet items. Do NOT include full English sentences.
- suggestions_en: English-only bullet items. Do NOT include Korean/Hangul.
- suggestions_ko: Korean-only bullet items. Do NOT include full English sentences.
- Pairing rule: each _en item must have its Korean translation at the same index in the corresponding _ko array.
- Final validation before output: if language is mixed in any list, correct it so _en contains only English and _ko contains only Korean.


---

Please show the result in the following format:

## Feedback

### Ideas / Content

[English - Paragraph: Ideas / Content]

--- 
### Organization / Structure

[English - Paragraph: Organization / Structure]

--- 

### Voice / Expression

[English - Paragraph: Voice / Expression]

--- 

### Word Choice / Vocabulary

[English - Paragraph: Word Choice / Vocabulary]

--- 

### Sentence Fluency / Conventions

[English - Paragraph: Sentence Fluency / Conventions]

--- 

### Strong Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Weak Points

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet

--- 

### Suggestions

- English sentence with bullet 
- English sentence with bullet 
- Korean sentence with bullet
- Korean sentence with bullet`;

export const AI_WRITING_GRAMMAR_REVISE_PROMPT = `Can you rewrite this writing using very easy words at a first-grade level in polite way without showing corrections and explanations in English with the difficulty level of ((level))? 
Evaluate the student's writing based on whether its content matches and stays relevant to this content. If the student's answer is not relevant to the content, write a new piece of writing related to the given content with approximately the same length as the student's original writing, and organize it with clear paragraph breaks.

# This is the content to check for the student's writing: 
"((grammar_points))"

# This is the student's writing:
"((topic))"`;

// Function to generate grammar-specific prompt with teacher's custom grammar instructions
export const AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS = {
  check_explanation_item: {
    type: 'object',
    additionalProperties: false,
    properties: {
      type: { type: 'string' },
      error: { type: 'string' },
      correction: { type: 'string' },
      message: { type: 'string' },
    },
    required: ['type', 'error', 'correction', 'message'],
  },
  check_default: {
    type: 'json_schema',
    name: 'writing_check_feedback_default',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['check'] },
        task_variant: { type: 'string', enum: ['book_report_default_fill'] },
        grammar_score: { type: 'integer', minimum: 0, maximum: 100 },
        my_writing_marked: { type: 'string' },
        corrections_marked: { type: 'string' },
        explanation_items_en: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        explanation_items_ko: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        total_error_count: { type: 'integer', minimum: 0 },
        section_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: ['my_writing', 'corrections', 'explanation_en', 'explanation_ko', 'total_error_count', 'total_score'],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'grammar_score',
        'my_writing_marked',
        'corrections_marked',
        'explanation_items_en',
        'explanation_items_ko',
        'total_error_count',
        'section_order',
      ],
      $defs: {
        check_explanation_item: {
          type: 'object',
          additionalProperties: false,
          properties: {
            type: { type: 'string' },
            error: { type: 'string' },
            correction: { type: 'string' },
            message: { type: 'string' },
          },
          required: ['type', 'error', 'correction', 'message'],
        },
      },
    },
  },
  check_default_w: {
    type: 'json_schema',
    name: 'writing_check_feedback_default_w',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['check'] },
        task_variant: { type: 'string', enum: ['book_report_default_fill_w'] },
        grammar_score: { type: 'integer', minimum: 0, maximum: 100 },
        my_writing_marked: { type: 'string' },
        corrections_marked: { type: 'string' },
        explanation_items_en: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        explanation_items_ko: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        total_error_count: { type: 'integer', minimum: 0 },
        section_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: ['my_writing', 'corrections', 'explanation_en', 'explanation_ko', 'total_error_count'],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'grammar_score',
        'my_writing_marked',
        'corrections_marked',
        'explanation_items_en',
        'explanation_items_ko',
        'total_error_count',
        'section_order',
      ],
      $defs: {
        check_explanation_item: {
          type: 'object',
          additionalProperties: false,
          properties: {
            type: { type: 'string' },
            error: { type: 'string' },
            correction: { type: 'string' },
            message: { type: 'string' },
          },
          required: ['type', 'error', 'correction', 'message'],
        },
      },
    },
  },
  check_custom: {
    type: 'json_schema',
    name: 'writing_check_feedback_custom',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['check'] },
        task_variant: { type: 'string', enum: ['ai_writing_grammar_check_prompt'] },
        grammar_score: { type: 'integer', minimum: 0, maximum: 100 },
        my_writing_marked: { type: 'string' },
        content_evaluation_en: { type: 'string' },
        content_evaluation_ko: { type: 'string' },
        corrections_marked: { type: 'string' },
        explanation_items_en: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        explanation_items_ko: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        total_error_count: { type: 'integer', minimum: 0 },
        section_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: [
              'my_writing',
              'content_evaluation',
              'corrections',
              'explanation_en',
              'explanation_ko',
              'total_error_count',
              'total_score',
            ],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'grammar_score',
        'my_writing_marked',
        'content_evaluation_en',
        'content_evaluation_ko',
        'corrections_marked',
        'explanation_items_en',
        'explanation_items_ko',
        'total_error_count',
        'section_order',
      ],
      $defs: {
        check_explanation_item: {
          type: 'object',
          additionalProperties: false,
          properties: {
            type: { type: 'string' },
            error: { type: 'string' },
            correction: { type: 'string' },
            message: { type: 'string' },
          },
          required: ['type', 'error', 'correction', 'message'],
        },
      },
    },
  },
  check_custom_w: {
    type: 'json_schema',
    name: 'writing_check_feedback_custom_w',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['check'] },
        task_variant: { type: 'string', enum: ['ai_writing_grammar_check_prompt_w'] },
        grammar_score: { type: 'integer', minimum: 0, maximum: 100 },
        my_writing_marked: { type: 'string' },
        content_evaluation_en: { type: 'string' },
        content_evaluation_ko: { type: 'string' },
        corrections_marked: { type: 'string' },
        explanation_items_en: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        explanation_items_ko: { type: 'array', items: { $ref: '#/$defs/check_explanation_item' } },
        total_error_count: { type: 'integer', minimum: 0 },
        section_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: ['my_writing', 'content_evaluation', 'corrections', 'explanation_en', 'explanation_ko', 'total_error_count'],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'grammar_score',
        'my_writing_marked',
        'content_evaluation_en',
        'content_evaluation_ko',
        'corrections_marked',
        'explanation_items_en',
        'explanation_items_ko',
        'total_error_count',
        'section_order',
      ],
      $defs: {
        check_explanation_item: {
          type: 'object',
          additionalProperties: false,
          properties: {
            type: { type: 'string' },
            error: { type: 'string' },
            correction: { type: 'string' },
            message: { type: 'string' },
          },
          required: ['type', 'error', 'correction', 'message'],
        },
      },
    },
  },
  revise: {
    type: 'json_schema',
    name: 'writing_revise_feedback',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['revise'] },
        revise_score: { type: 'integer', minimum: 0, maximum: 100 },
        revised_writing: { type: 'string' },
        revision_notes_en: { type: 'array', items: { type: 'string' } },
        revision_notes_ko: { type: 'array', items: { type: 'string' } },
        section_order: {
          type: 'array',
          items: { type: 'string', enum: ['revised_writing', 'revision_notes_en', 'revision_notes_ko'] },
        },
      },
      required: ['task_type', 'revise_score', 'revised_writing', 'revision_notes_en', 'revision_notes_ko', 'section_order'],
    },
  },
  comment: {
    type: 'json_schema',
    name: 'writing_comment_feedback',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['comment'] },
        task_variant: { type: 'string', enum: ['book_report_comment_list'] },
        overall_score: { type: 'integer', minimum: 0, maximum: 100 },
        estimated_toefl_score: { type: 'integer', minimum: 0, maximum: 30 },
        toefl_feedback_en: {
          type: 'string',
          maxLength: 220,
          description: 'One concise sentence, around 15 words.',
        },
        total_feedback: { type: 'string' },
        enhanced_guidance_en: { type: 'string' },
        enhanced_guidance_ko: { type: 'string' },
        section_scores: {
          type: 'object',
          additionalProperties: false,
          properties: {
            topic_concluding_sentence: { type: 'integer', minimum: 0, maximum: 20 },
            facts_and_logic: { type: 'integer', minimum: 0, maximum: 20 },
            voice: { type: 'integer', minimum: 0, maximum: 20 },
            organization: { type: 'integer', minimum: 0, maximum: 20 },
            word_choice: { type: 'integer', minimum: 0, maximum: 20 },
          },
          required: ['topic_concluding_sentence', 'facts_and_logic', 'voice', 'organization', 'word_choice'],
        },
        blocks: {
          type: 'object',
          additionalProperties: false,
          properties: {
            opinion: { type: 'string' },
            topic_concluding_sentence: { type: 'string' },
            facts_and_logic: { type: 'string' },
            voice: { type: 'string' },
            organization: { type: 'string' },
            word_choice: { type: 'string' },
            strong_points_en: { type: 'array', items: { type: 'string' } },
            strong_points_ko: { type: 'array', items: { type: 'string' } },
            weak_points_en: { type: 'array', items: { type: 'string' } },
            weak_points_ko: { type: 'array', items: { type: 'string' } },
            suggestions_en: { type: 'array', items: { type: 'string' } },
            suggestions_ko: { type: 'array', items: { type: 'string' } },
          },
          required: [
            'opinion',
            'topic_concluding_sentence',
            'facts_and_logic',
            'voice',
            'organization',
            'word_choice',
            'strong_points_en',
            'strong_points_ko',
            'weak_points_en',
            'weak_points_ko',
            'suggestions_en',
            'suggestions_ko',
          ],
        },
        block_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: [
              'opinion',
              'topic_concluding_sentence',
              'facts_and_logic',
              'voice',
              'organization',
              'word_choice',
              'strong_points',
              'weak_points',
              'suggestions',
              'toefl_score',
            ],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'overall_score',
        'estimated_toefl_score',
        'toefl_feedback_en',
        'total_feedback',
        'enhanced_guidance_en',
        'enhanced_guidance_ko',
        'section_scores',
        'blocks',
        'block_order',
      ],
    },
  },
  comment_w: {
    type: 'json_schema',
    name: 'writing_comment_feedback_w',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['comment'] },
        task_variant: { type: 'string', enum: ['book_report_comment_list_w'] },
        overall_score: { type: 'integer', minimum: 0, maximum: 100 },
        estimated_toefl_score: { type: 'integer', minimum: 0, maximum: 30 },
        toefl_feedback_en: {
          type: 'string',
          maxLength: 220,
          description: 'One concise sentence, around 15 words.',
        },
        total_feedback: { type: 'string' },
        enhanced_guidance_en: { type: 'string' },
        enhanced_guidance_ko: { type: 'string' },
        section_scores: {
          type: 'object',
          additionalProperties: false,
          properties: {
            ideas_content: { type: 'integer', minimum: 0, maximum: 20 },
            organization_structure: { type: 'integer', minimum: 0, maximum: 20 },
            voice_expression: { type: 'integer', minimum: 0, maximum: 20 },
            word_choice_vocabulary: { type: 'integer', minimum: 0, maximum: 20 },
            sentence_fluency_conventions: { type: 'integer', minimum: 0, maximum: 20 },
          },
          required: [
            'ideas_content',
            'organization_structure',
            'voice_expression',
            'word_choice_vocabulary',
            'sentence_fluency_conventions',
          ],
        },
        blocks: {
          type: 'object',
          additionalProperties: false,
          properties: {
            ideas_content: { type: 'string' },
            organization_structure: { type: 'string' },
            voice_expression: { type: 'string' },
            word_choice_vocabulary: { type: 'string' },
            sentence_fluency_conventions: { type: 'string' },
            strong_points_en: { type: 'array', items: { type: 'string' } },
            strong_points_ko: { type: 'array', items: { type: 'string' } },
            weak_points_en: { type: 'array', items: { type: 'string' } },
            weak_points_ko: { type: 'array', items: { type: 'string' } },
            suggestions_en: { type: 'array', items: { type: 'string' } },
            suggestions_ko: { type: 'array', items: { type: 'string' } },
          },
          required: [
            'ideas_content',
            'organization_structure',
            'voice_expression',
            'word_choice_vocabulary',
            'sentence_fluency_conventions',
            'strong_points_en',
            'strong_points_ko',
            'weak_points_en',
            'weak_points_ko',
            'suggestions_en',
            'suggestions_ko',
          ],
        },
        block_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: [
              'ideas_content',
              'organization_structure',
              'voice_expression',
              'word_choice_vocabulary',
              'sentence_fluency_conventions',
              'strong_points',
              'weak_points',
              'suggestions',
              'toefl_score',
            ],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'overall_score',
        'estimated_toefl_score',
        'toefl_feedback_en',
        'total_feedback',
        'enhanced_guidance_en',
        'enhanced_guidance_ko',
        'section_scores',
        'blocks',
        'block_order',
      ],
    },
  },
  comment_full: {
    type: 'json_schema',
    name: 'writing_comment_full_feedback',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['comment-full'] },
        task_variant: { type: 'string', enum: ['ai_writing_grammar_comment_prompt'] },
        overall_score: { type: 'integer', minimum: 0, maximum: 100 },
        estimated_toefl_score: { type: 'integer', minimum: 0, maximum: 30 },
        toefl_feedback_en: {
          type: 'string',
          maxLength: 220,
          description: 'One concise sentence, around 15 words.',
        },
        total_feedback: { type: 'string' },
        enhanced_guidance_en: { type: 'string' },
        enhanced_guidance_ko: { type: 'string' },
        section_scores: {
          type: 'object',
          additionalProperties: false,
          properties: {
            topic_concluding_sentence: { type: 'integer', minimum: 0, maximum: 20 },
            facts_and_logic: { type: 'integer', minimum: 0, maximum: 20 },
            voice: { type: 'integer', minimum: 0, maximum: 20 },
            organization: { type: 'integer', minimum: 0, maximum: 20 },
            word_choice: { type: 'integer', minimum: 0, maximum: 20 },
          },
          required: ['topic_concluding_sentence', 'facts_and_logic', 'voice', 'organization', 'word_choice'],
        },
        blocks: {
          type: 'object',
          additionalProperties: false,
          properties: {
            opinion: { type: 'string' },
            topic_concluding_sentence: { type: 'string' },
            facts_and_logic: { type: 'string' },
            voice: { type: 'string' },
            organization: { type: 'string' },
            word_choice: { type: 'string' },
            strong_points_en: { type: 'array', items: { type: 'string' } },
            strong_points_ko: { type: 'array', items: { type: 'string' } },
            weak_points_en: { type: 'array', items: { type: 'string' } },
            weak_points_ko: { type: 'array', items: { type: 'string' } },
            suggestions_en: { type: 'array', items: { type: 'string' } },
            suggestions_ko: { type: 'array', items: { type: 'string' } },
          },
          required: [
            'opinion',
            'topic_concluding_sentence',
            'facts_and_logic',
            'voice',
            'organization',
            'word_choice',
            'strong_points_en',
            'strong_points_ko',
            'weak_points_en',
            'weak_points_ko',
            'suggestions_en',
            'suggestions_ko',
          ],
        },
        block_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: [
              'opinion',
              'topic_concluding_sentence',
              'facts_and_logic',
              'voice',
              'organization',
              'word_choice',
              'strong_points',
              'weak_points',
              'suggestions',
              'toefl_score',
            ],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'overall_score',
        'estimated_toefl_score',
        'toefl_feedback_en',
        'total_feedback',
        'enhanced_guidance_en',
        'enhanced_guidance_ko',
        'section_scores',
        'blocks',
        'block_order',
      ],
    },
  },
  comment_full_w: {
    type: 'json_schema',
    name: 'writing_comment_full_feedback_w',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['comment-full'] },
        task_variant: { type: 'string', enum: ['ai_writing_grammar_comment_prompt_w'] },
        overall_score: { type: 'integer', minimum: 0, maximum: 100 },
        estimated_toefl_score: { type: 'integer', minimum: 0, maximum: 30 },
        toefl_feedback_en: {
          type: 'string',
          maxLength: 220,
          description: 'One concise sentence, around 15 words.',
        },
        total_feedback: { type: 'string' },
        enhanced_guidance_en: { type: 'string' },
        enhanced_guidance_ko: { type: 'string' },
        section_scores: {
          type: 'object',
          additionalProperties: false,
          properties: {
            ideas_content: { type: 'integer', minimum: 0, maximum: 20 },
            organization_structure: { type: 'integer', minimum: 0, maximum: 20 },
            voice_expression: { type: 'integer', minimum: 0, maximum: 20 },
            word_choice_vocabulary: { type: 'integer', minimum: 0, maximum: 20 },
            sentence_fluency_conventions: { type: 'integer', minimum: 0, maximum: 20 },
          },
          required: [
            'ideas_content',
            'organization_structure',
            'voice_expression',
            'word_choice_vocabulary',
            'sentence_fluency_conventions',
          ],
        },
        blocks: {
          type: 'object',
          additionalProperties: false,
          properties: {
            ideas_content: { type: 'string' },
            organization_structure: { type: 'string' },
            voice_expression: { type: 'string' },
            word_choice_vocabulary: { type: 'string' },
            sentence_fluency_conventions: { type: 'string' },
            strong_points_en: { type: 'array', items: { type: 'string' } },
            strong_points_ko: { type: 'array', items: { type: 'string' } },
            weak_points_en: { type: 'array', items: { type: 'string' } },
            weak_points_ko: { type: 'array', items: { type: 'string' } },
            suggestions_en: { type: 'array', items: { type: 'string' } },
            suggestions_ko: { type: 'array', items: { type: 'string' } },
          },
          required: [
            'ideas_content',
            'organization_structure',
            'voice_expression',
            'word_choice_vocabulary',
            'sentence_fluency_conventions',
            'strong_points_en',
            'strong_points_ko',
            'weak_points_en',
            'weak_points_ko',
            'suggestions_en',
            'suggestions_ko',
          ],
        },
        block_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: [
              'ideas_content',
              'organization_structure',
              'voice_expression',
              'word_choice_vocabulary',
              'sentence_fluency_conventions',
              'strong_points',
              'weak_points',
              'suggestions',
              'toefl_score',
            ],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'overall_score',
        'estimated_toefl_score',
        'toefl_feedback_en',
        'total_feedback',
        'enhanced_guidance_en',
        'enhanced_guidance_ko',
        'section_scores',
        'blocks',
        'block_order',
      ],
    },
  },
  word: {
    type: 'json_schema',
    name: 'writing_word_feedback',
    strict: true,
    schema: {
      type: 'object',
      additionalProperties: false,
      properties: {
        task_type: { type: 'string', enum: ['word'] },
        task_variant: { type: 'string', enum: ['book_report_word'] },
        vocabulary_score: { type: 'integer', minimum: 0, maximum: 100 },
        word: { type: 'string' },
        part_of_speech: { type: 'string' },
        meanings_en: { type: 'array', items: { type: 'string' } },
        meanings_ko: { type: 'array', items: { type: 'string' } },
        sentence_1_en: { type: 'string' },
        sentence_1_ko: { type: 'string' },
        sentence_2_en: { type: 'string' },
        sentence_2_ko: { type: 'string' },
        synonyms: { type: 'array', items: { type: 'string' } },
        field_order: {
          type: 'array',
          items: {
            type: 'string',
            enum: ['word', 'meaning_en', 'meaning_ko', 'sentence_1_en', 'sentence_1_ko', 'sentence_2_en', 'sentence_2_ko', 'synonyms'],
          },
        },
      },
      required: [
        'task_type',
        'task_variant',
        'vocabulary_score',
        'word',
        'part_of_speech',
        'meanings_en',
        'meanings_ko',
        'sentence_1_en',
        'sentence_1_ko',
        'sentence_2_en',
        'sentence_2_ko',
        'synonyms',
        'field_order',
      ],
    },
  },
};

export const getAiCoachWritingStructuredOutputByType = (type) => {
  if (type === 'check') return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_default;
  if (type === 'revise') return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.revise;
  if (type === 'comment-full') return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment_full;
  if (type === 'comment') return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment;
  if (type === 'word') return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.word;
  return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_default;
};

export const getAiCoachWritingCheckStructuredOutput = (customGrammarPrompt = null, company = null) => {
  const isWEnglish = company === 'w_english';
  if (customGrammarPrompt) {
    return isWEnglish ? AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_custom_w : AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_custom;
  }
  return isWEnglish ? AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_default_w : AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.check_default;
};

export const getAiCoachWritingReviseStructuredOutput = () => AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.revise;

export const getAiCoachWritingCommentStructuredOutput = (customGrammarPrompt = null, company = null, isFullFeedback = false) => {
  const isWEnglish = company === 'w_english';
  const full = !!isFullFeedback;
  if (isWEnglish && full) return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment_full_w;
  if (isWEnglish && !full) return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment_w;
  if (!isWEnglish && full) return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment_full;
  return AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.comment;
};

export const getAiCoachWritingWordStructuredOutput = () => AI_COACH_WRITING_STRUCTURED_OUTPUT_FORMATS.word;

export const generateGrammarCheckPrompt = (text, customGrammarPrompt = null, level, language, company = null) => {
  // Determine which templates to use based on company
  const isWEnglish = company === 'w_english';
  const checkPromptTemplate = isWEnglish ? AI_WRITING_GRAMMAR_CHECK_PROMPT_W : AI_WRITING_GRAMMAR_CHECK_PROMPT;
  const defaultFillTemplate = isWEnglish ? BOOK_REPORT_DEFAULT_FILL_W : BOOK_REPORT_DEFAULT_FILL;

  // If teacher provided custom grammar prompt, insert it into the template
  if (customGrammarPrompt) {
    return checkPromptTemplate
      .replaceAll('((grammar_points))', customGrammarPrompt)
      .replaceAll('((grammar_list))', 'the grammar points specified above')
      .replaceAll('((topic))', text);
  }

  // If no custom prompt, return default prompt
  return defaultFillTemplate.replaceAll('((level))', level).replaceAll('((topic))', text).replaceAll('((language))', language);
};

export const generateGrammarCommentPrompt = (text, customGrammarPrompt = null, level, language, company = null) => {
  const isWEnglish = company === 'w_english';
  const commentPromptTemplate = isWEnglish ? AI_WRITING_GRAMMAR_COMMENT_PROMPT_W : AI_WRITING_GRAMMAR_COMMENT_PROMPT;
  const defaultCommentTemplate = isWEnglish ? BOOK_REPORT_COMMENT_LIST_W : BOOK_REPORT_COMMENT_LIST;

  if (customGrammarPrompt) {
    return commentPromptTemplate
      .replaceAll('((grammar_points))', customGrammarPrompt)
      .replaceAll('((topic))', text)
      .replaceAll('((level))', level)
      .replaceAll('((language))', language);
  }

  return defaultCommentTemplate.replaceAll('((topic))', text).replaceAll('((level))', level).replaceAll('((language))', language);
};

export const generateGrammarRevisePrompt = (text, customGrammarPrompt = null, level, language) => {
  // If teacher provided custom grammar prompt, insert it into the template
  if (customGrammarPrompt) {
    return AI_WRITING_GRAMMAR_REVISE_PROMPT.replaceAll('((grammar_points))', customGrammarPrompt)
      .replaceAll('((topic))', text)
      .replaceAll('((level))', level)
      .replaceAll('((language))', language);
  }

  // If no custom prompt, return default prompt
  return BOOK_REPORT_REVISE_FILL?.replaceAll('((level))', level)?.replaceAll('((topic))', text)?.replaceAll('((language))', language);
};
